// Angular
import { NgModule } from '@angular/core';

// Afidium
import { SashaSideLinksComponent } from 'app_sasha/pages/sasha-home/components/sasha-side-links/sasha-side-links.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { CommonModule } from "@angular/common";
import { PocModalModule } from "../poc-modal/poc-modal.module";
import { MatDialogModule } from "@angular/material/dialog";
import { ApiResourceModule } from "libraries/service/apiResource/apiResource.module";
import { ResourceModule } from "libraries/service/resource/resource.module";

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        BtnModule,
        CardModule,
        PermissionModule,
        LoaderModule,
        PocModalModule,
        ApiResourceModule,
        ResourceModule,
    ],
    exports: [
        SashaSideLinksComponent,
    ],
    declarations: [
        SashaSideLinksComponent,
    ],
})
export class SashaSideLinksModule { }
